import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Lock } from "@phosphor-icons/react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@mysteryserved.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try { await login(email, password); nav("/admin"); }
    catch { setError("Invalid credentials"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-ms-cream px-6">
      <div className="w-full max-w-md">
        <p className="serif text-3xl text-ms-earth">Mystery <em className="text-ms-brass">Served</em></p>
        <p className="label-eyebrow text-ms-stone mt-1">Operator console</p>
        <form onSubmit={submit} className="mt-10 space-y-5 bg-white border border-ms-edge rounded-2xl p-8" data-testid="admin-login-form">
          <div>
            <label className="label-eyebrow text-ms-stone">Email</label>
            <input value={email} onChange={e=>setEmail(e.target.value)} required className="mt-2 w-full border border-ms-edge rounded-md px-4 py-3 bg-white focus:border-ms-brass outline-none" data-testid="admin-email" />
          </div>
          <div>
            <label className="label-eyebrow text-ms-stone">Password</label>
            <input type="password" value={password} onChange={e=>setPassword(e.target.value)} required className="mt-2 w-full border border-ms-edge rounded-md px-4 py-3 bg-white focus:border-ms-brass outline-none" data-testid="admin-password" />
          </div>
          {error && <p className="text-ms-danger text-sm" data-testid="admin-login-error">{error}</p>}
          <button disabled={loading} type="submit" className="w-full py-3 bg-ms-earth text-ms-cream rounded-md hover:bg-ms-earth/90 transition-all label-eyebrow flex items-center justify-center gap-2" data-testid="admin-login-submit">
            <Lock size={16} /> {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
